import type { MemoryStatus } from '@cortex/types';

/**
 * Shared archived/pending/rejected/approved badge for a unified memory row —
 * same lifecycle logic previously duplicated between MemoryListRow's local
 * `StatusBadge` and the PA chat card's local `MemoryStatusBadge`.
 * `pendingLabel` lets each surface keep its existing copy ("pending" on the
 * list vs. "pending review" on the chat card).
 */
export function MemoryStatusBadge({
  status,
  archived,
  pendingLabel = 'pending review',
}: {
  status: MemoryStatus;
  archived: boolean;
  pendingLabel?: string;
}) {
  if (archived) return <span className="badge badge--neutral">archived</span>;
  if (status === 'PENDING' || status === 'CANDIDATE') {
    return <span className="badge badge--warning">{pendingLabel}</span>;
  }
  if (status === 'REJECTED') return <span className="badge badge--neutral">rejected</span>;
  return <span className="badge badge--success">approved</span>;
}
